import CoreInputTextHint from "./CoreInputTextHint";
import createFabric from "../../../../../fabrics/createFabric";

export default createFabric("Hint", CoreInputTextHint);
